import { ToastrService } from 'ngx-toastr';

import { Component, OnInit, Inject } from '@angular/core';

import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormGroup, FormControl, FormBuilder, Validators } from '@angular/forms';

import { SpinnerService } from '../../../services/spinner.service';
import { ApiBaseAttribute, ApiSetUploadedFilesAttributesRequest } from '../../../api-client-module';
import { ProjectLanguage } from '../../../firestore-models/project-language';

import { ConfigurationService } from '../../../configuration.service';
import { ApiClientService } from '../../../api-client.service';
import { AppConst } from '../../../app-const';
import { MultiNameDialogComponent } from '../../../common/multi-name-dialog/multi-name-dialog.component';
import { TranslateService } from '@ngx-translate/core';

export interface UploadedFilesAttributeDialogData {
  change_type: number;
  uploadedFilesAttribute?: ApiBaseAttribute;
}

@Component({
  selector: 'app-uploaded-files-attribute-dialog',
  templateUrl: './uploaded-files-attribute-dialog.component.html',
  styleUrls: ['./uploaded-files-attribute-dialog.component.css'],
  standalone: false,
})
export class UploadedFilesAttributeDialogComponent implements OnInit {

  projectId: string;
  //アップロードファイル属性情報
  uploadedFilesAttribute?: ApiBaseAttribute;
  isAdded: boolean = false;
  projectLanguages!: Array<ProjectLanguage>;

  //アップロードファイル属性情報フォーム
  uploadedFilesAttributeFormGroup!: FormGroup;
  uploadedFilesAttributeIdControl!: FormControl;
  uploadedFilesAttributeNameControl!: FormControl;

  projectBaseLang: string = 'ja';

  constructor(
    public dialogRef: MatDialogRef<UploadedFilesAttributeDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: UploadedFilesAttributeDialogData,
    private formBuilder: FormBuilder,
    public dialog: MatDialog,
    private configurationService: ConfigurationService,
    private translate: TranslateService,
    private apiClientService: ApiClientService,
    private spinnerService: SpinnerService,
    private toastr: ToastrService,
  ) {
    this.projectId = this.configurationService.getProjectId();
   }

  ngOnInit(): void {
    this.projectLanguages = this.configurationService.getProject().languages!;
    this.uploadedFilesAttribute = this.data.uploadedFilesAttribute;
    if (!this.uploadedFilesAttribute) {
      this.uploadedFilesAttribute = {
        attribute_id: '',
        attribute_names: [],
        project_id: this.projectId,
        enabled: true
      };
      this.isAdded = true;
    }
    this.createForm();
    this.uploadedFilesAttributeIdControl = this.uploadedFilesAttributeFormGroup.get('uploadedFilesAttributeId') as FormControl;
    this.uploadedFilesAttributeNameControl = this.uploadedFilesAttributeFormGroup.get('uploadedFilesAttributeName') as FormControl;
    this.projectBaseLang = this.configurationService.getProject().project_base_lang;
  }

  //以下、フォームの記入エラー表示
  public getErrorMessageToUploadedFilesAttributeId() {
    return this.uploadedFilesAttributeIdControl.hasError('required')
      ? this.translate.instant('必須項目')
      : this.uploadedFilesAttributeIdControl.hasError('pattern')
        ? this.translate.instant('半角数字')
        : '';
  }

  public getErrorMessageToUploadedFilesAttributeName() {
    return this.uploadedFilesAttributeNameControl.hasError('required')
      ? this.translate.instant('必須項目')
      : '';
  }

  //フォームの値を各要素に代入
  private createForm() {
    this.uploadedFilesAttributeFormGroup = this.formBuilder.group(
      {
        uploadedFilesAttributeId: [this.uploadedFilesAttribute!.attribute_id, [Validators.required, Validators.pattern('^[0-9]+$')]],
        uploadedFilesAttributeName: [this.uploadedFilesAttribute!.attribute_names, [Validators.required]]
      }
    );
  }

  //更新ボタン
  addUploadedFilesAttribute(): void {
    if (this.uploadedFilesAttributeFormGroup.valid) {
      this.uploadedFilesAttribute!.attribute_id = this.uploadedFilesAttributeIdControl.value;
      this.uploadedFilesAttribute!.attribute_names = this.uploadedFilesAttributeNameControl.value;
      if (this.uploadedFilesAttribute) {
        let request: ApiSetUploadedFilesAttributesRequest = {
          access_token: '',
          change_type: this.data.change_type,
          attributes: [this.uploadedFilesAttribute]
        }
        this.spinnerService.openSpinner();
        this.apiClientService.setUploadedFilesAttributes(request).then(
          response => {
            if (response!.ret === AppConst.API_RET_SUCCESS) {
              this.toastr.success(this.translate.instant('登録しました。'));
              this.dialogRef.close();
            } else if (response!.ret === AppConst.API_RET_ALREADY_EXIST_DATA) {
              this.toastr.error(this.translate.instant('既に同じIDが登録済みです。'), '', { timeOut : 5000 });
            } else {
              console.error('api update error. ret='+response!.ret);
              this.toastr.error(this.translate.instant('登録できませんでした。'), '', { timeOut : 5000 });
            }
          }
        ).catch(
          error => {
            console.log(error);
            this.toastr.error(this.translate.instant('登録できませんでした。'), '', { timeOut : 5000 });
          }
        ).finally(
          () => {
            this.spinnerService.closeSpinner();
          }
        );
      }
    }
  }

  //属性名称ダイアログ
  openAttributeNameDialog(): void {
    const dialogRef = this.dialog.open(MultiNameDialogComponent, {
      width: '60%',
      height: '90%',
      disableClose: true,
      data: { names: this.uploadedFilesAttribute!.attribute_names }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (!!result) {
        this.uploadedFilesAttribute!.attribute_names = result;
        this.uploadedFilesAttributeNameControl.setValue(this.uploadedFilesAttribute!.attribute_names);
      }
    });
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

}
